/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toast } from "react-hot-toast";
import { GET_USER_APPLICATION_TABLE } from "../pages/ApplicationList/graphql";

const MODULE_NAME = "ApplicationListService";
const log: any = LoggerModule.getInstance();
interface TableProps {
    action: String;
    applicationFor: String;
    applicationId: String;
    applicationStatus: String;
    appliedOn: String;
    familyName: String;
    givenName: String;
    paymentReceipt: String;
    processDuration: number;
    processingFee: number;
}
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ApplicationListService {
    private static instance: ApplicationListService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ApplicationListService {
        if (!ApplicationListService.instance) {
            ApplicationListService.instance = new ApplicationListService(props);
        }
        return ApplicationListService.instance;
    }

    async applicationList(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if (!client) {
            console.log("graphql-gateway is not available !!!!!!");
        }

        console.log("applicationList()::applicationList()->applicationList..");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_USER_APPLICATION_TABLE,
                    variables: {
                        criteria: filter,
                        skip: skip,
                        limit: limit,
                    },

                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getCertificatesTable : ", res?.data);
                if (res?.data?.getUserApplicationTable) {
                    return {
                        data: {
                            columnDefs: this.removePropertiesFromList(
                                res?.data?.getUserApplicationTable?.data
                                    ?.columnDefs
                            ),
                            rowData: this.updateDataForAppliedFor(
                                res?.data?.getUserApplicationTable?.data
                                    ?.rowData
                            ),
                        },
                        pageSize: res?.data?.getUserApplicationTable?.pageSize,
                        totalCount:
                            res?.data?.getUserApplicationTable?.totalCount,
                        totalPages:
                            res?.data?.getUserApplicationTable?.totalPages,
                    };
                }
            }
        } catch (err: any) {
            console.log(err);
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    removePropertiesFromList = (list: any[]): any[] => {
        const propertiesToRemove = [
            "familyName",
            "paymentReceipt",
            "applierName",
            "processDuration",
        ];
        if (!list) {
            return list;
        }

        const newCol = list.filter((item) => {
            return !propertiesToRemove.includes(item.accessor);
        });
        return newCol;
    };

    updateDataForAppliedFor = (list: TableProps[]): any[] => {
        if (list && list.length>0) {
            for (const i of list) {
                switch (i.applicationStatus) {
                    case "INITIATED":
                        i.applicationStatus = "Initiated";
                        break;
                    case "PAYMENT-COMPLETE":
                        i.applicationStatus = "Payment is completed";
                        break;
                    case "CRO-VERIFIED" || "OC-APPROVED":
                        i.applicationStatus = "Police Verification";
                        break;
                    case "READY-FOR-DOWNLOAD":
                        i.applicationStatus = "Ready to Download";
                        break;
                    case "ADDITIONAL-INFO-REQUIRED":
                        i.applicationStatus = "Additional details required";
                        break;
                    case "CANCELLED":
                        i.applicationStatus = "Cancelled";
                        break;
                }
            }

            return list;
        }
        return list;
    };
}
